import React, { memo } from 'react'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Container.scss'
const rootClassName = 'component-container'

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  fluid?: boolean
  verticalPadding?: boolean
  hasMobileButton?: boolean
  hasHeader?: boolean
  hasAdvancedHeader?: boolean
}

function Container(props: ContainerProps) {
  const getProps = () => {
    const p = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.className,
        props.fluid ? 'fluid' : '',
        props.verticalPadding ? 'vertical-padding' : '',
        props.hasMobileButton ? 'has-mobile-button' : '',
        props.hasHeader ? 'has-header' : '',
        props.hasAdvancedHeader ? 'has-advanced-header' : ''
      ])
    }
    delete p.fluid
    delete p.verticalPadding
    delete p.hasMobileButton
    delete p.hasHeader
    delete p.hasAdvancedHeader
    return p
  }

  return (
    <div {...getProps()}>
      <div className={`${rootClassName}-insider`}>{props.children}</div>
    </div>
  )
}

Container.defaultProps = {
  fluid: false,
  verticalPadding: false,
  hasMobileButton: false,
  hasAdvancedHeader: false,
  hasHeader: false
}

export default memo(Container)
